import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { answerQuestion } from '../../actions/tableQrcodeActions';
import BaseModal from '../../components/common/base-modal'
import ModalHeader from '../../components/common/base-modal/ModalHeader'
import { MODAL_KEYS } from '../../constants';
import useModal from '../../hooks/useModal';
import { getRestaurantSettings } from '../../selectors';

import { getFingerId } from '../../utils'

const ModalTableQrcodeQuestion = () => {
    const dispatch = useDispatch();
    const { isOpen, toggleModal } = useModal(MODAL_KEYS.tableQrcodeQuestion);
    const { tableSetting } = useSelector(getRestaurantSettings)

    const handleAnswer = async answer => {
        const finger = await getFingerId();
        dispatch(answerQuestion({
            params: {
                answer,
                finger
            }
        }));

        toggleModal(false);
    }

    return (
        <BaseModal
            isOpen={isOpen && tableSetting?.question && tableSetting?.options?.length}
            contentClassName="modal-table-qrcode-question"
            onRequestClose={() => toggleModal(false)}
            centered
        >
            <ModalHeader onClose={() => toggleModal(false)}>
                {tableSetting?.question}
            </ModalHeader>
            <div
                className="answer-list paragraph-2 mt-4"
            >
                {(tableSetting?.options || []).map((option, index) => {
                    const [ answer ] = (option || "").split("::::");
                    return (
                        <div
                            key={index}
                            onClick={() => handleAnswer(option)}
                            className="answer-item"
                        >
                            {answer}
                        </div>
                    );
                })}
            </div>
        </BaseModal>
    )
}

export default ModalTableQrcodeQuestion
